import React, { useRef, useEffect } from 'react';
import ExpectantParents from '../Components/Services/ExpectantParents';
// import NewbornCare from '../Components/Services/NewbornCare';  // Import the new component
import WellChecks from '../Components/Services/WellChecks';    // Import the new component
import FunctionalMedicine from '../Components/Services/FunctionalMedicine';
import SameDaySickVisits from '../Components/Services/SameDaySickVisits';
import CommonMedicalConditions from '../Components/Services/CommonMedicalConditions';
import InfoCard from '../Components/InfoCard';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigateAndScroll } from '../Hooks/useNavigateAndScroll';



function Services() {
  const barRef = useRef(null);

  const navigateAndScroll = useNavigateAndScroll();
  const navigate = useNavigate();
  const location = useLocation();

  const infoCardsData = {
    expectantParents: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/expectant_parents.webp",
      infoTitle: "Expectant Parents",
      infoText: "Comprehensive prenatal care, guidance, and support for expecting mothers and families preparing for their new arrival.",
      path: "/services/expectant-parents"
    },
    wellChecks: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Well+Check.webp",
      infoTitle: "Well Checks", 
      infoText: "Regular preventive care appointments to monitor your child's growth, development, and overall health at every stage.",
      path: "/services/well-checks"
    },
    sameDaySickVisits: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/sick+same+day.webp",
      infoTitle: "Same Day Sick Visits",
      infoText: "Prompt medical attention for acute illnesses and urgent health concerns when your child needs immediate care.",
      path: "/services/same-day-sick-visits"
    },
    functionalMedicine: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Functional+Medicine.webp",
      infoTitle: "Functional Medicine",
      infoText: "Holistic approach to healthcare focusing on identifying and addressing the root causes of health issues for optimal wellness.",
      path: "/services/functional-medicine"
    },
    commonMedicalConditions: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/common+medical+conditions.webp",
      infoTitle: "Common Medical Conditions",
      infoText: "Information and treatment options for frequently encountered pediatric and family health conditions and concerns.",
      path: "/services/common-medical-conditions"
    }
  };
  

  const handleNavigateAndScroll = (pathname, sectionId) => {
    if (location.pathname !== pathname) {
      navigate(pathname);
    }

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Adjust the timeout as needed to ensure the page has navigated
  };

  const handleCardNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (barRef.current) {
        const barTop = barRef.current.getBoundingClientRect().top;
        if (barTop <= 0) {
          barRef.current.classList.add('sticky', 'top-0', 'shadow-md');
        } else {
          barRef.current.classList.remove('sticky', 'top-0', 'shadow-md');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section && barRef.current) {
      const stickyBarHeight = barRef.current.offsetHeight;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY; // <= Use scrollY here
      const offset = 7;
      const scrollPosition = sectionPosition - stickyBarHeight - offset;
  
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
    }
  };

  // Generate info cards using for loop
  const generateInfoCards = () => {
    const infoCardComponents = [];
    
    for (const key in infoCardsData) {
      const cardData = infoCardsData[key];
      infoCardComponents.push(
        <InfoCard
          key={key}
          image={cardData.image}
          infoTitle={cardData.infoTitle}
          infoText={cardData.infoText}
          path={cardData.path}
          onNavigate={handleCardNavigation}
        />
      );
    }
    
    return infoCardComponents;
  };
  

  return (
    <div>
      <div className="flex justify-center smartphone:hidden items-center relative">
        <div className="relative w-auto z-1 mt-[-140px]">
          <img
            className="w-full h-auto shadow-lg mt-2"
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Sevices+Final_.webp"
            alt="Children sitting with hands closed"
          />
        </div>
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 smartphone:hidden">
            <button className="text-white font-bold bg-custom-regularOrange px-2 py-1 rounded-md hover:bg-custom-darkOrange"
            onClick={() => navigateAndScroll('/patient-center/new-patient')}>
              New to our practice - LET US HELP YOU
            </button>
          </div>
      </div>

      {/* Sticky Bar Below the Image */}
      {/* <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50">
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => navigateAndScroll()}>Expectant Parents</button>
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => navigateAndScroll()}>Well Checks</button>
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => navigateAndScroll()}>Same Day Sick Visits</button>
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => navigateAndScroll()}>Functional Medicine</button>
        <button className="p-1 text-sm cursor-pointer grow-text" onClick={() => navigateAndScroll()}>Common Medical Conditions</button>
      </div> */}

      {/* <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50">
        {Object.values(infoCardsData).map((card) => (
          <button
            key={card.infoTitle}
            className="p-1 text-sm cursor-pointer grow-text"
            onClick={() => navigateAndScroll(card.path, card.infoTitle)}
          >
            {card.infoTitle}
          </button>
        ))}
      </div> */}


      {/* Info Cards Grid Section */}
      <div className="py-12 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto">
            {generateInfoCards()}
          </div>
        </div>
      </div>

      {/* Section Content */}
      {/* <section id="expectantParents">
        <ExpectantParents />
      </section>
      
      <section id="wellChecks">
        <WellChecks />
      </section>
      <section id="sameDaySickVisits">
        <SameDaySickVisits />
      </section>
      <section id="functionalMedicine">
        <FunctionalMedicine />
      </section>
      <section id="commonMedicalConditions">
         <CommonMedicalConditions />
      </section> */}
    </div>
  );
}

export default Services;